import catalog from './reviews/publishedReviews.json';

// Generated from src/content/patientReviews.json by scripts/build-review-widgets.mjs.
// Page, native components, legacy badges, iframe and custom element share this release.
export const REVIEW_CATALOG=catalog;
export const GOOGLE_RATING=catalog.google.rating;
export const GOOGLE_REVIEW_COUNT=catalog.google.count;
export const VERIFIED_ON=catalog.google.verifiedOn;
export const GOOGLE_REVIEW_URL=catalog.google.profileUrl;
export const GOOGLE_WRITE_REVIEW_URL=catalog.google.writeReviewUrl;
export const RATING_DISPLAY=GOOGLE_RATING.toFixed(1);
export const RATING_STARS=`${RATING_DISPLAY}★`;
export const REVIEW_COUNT_DISPLAY=String(GOOGLE_REVIEW_COUNT);
export const RATING_SUMMARY=`${RATING_DISPLAY} stars · ${REVIEW_COUNT_DISPLAY} Google reviews`;
export const REVIEW_TOPICS=[['all','All experiences'],['anxiety','Feeling comfortable'],['cosmetic','Smile transformations'],['general','Everyday care'],['financing','Clear costs'],['tech','Technology']];
export const GOOGLE_REVIEWS=catalog.reviews;
export function reviewsFor(topic,limit=3) {
  const wanted=Array.isArray(topic)?topic:topic?[topic]:[];
  // Only true topic matches: do not relabel an unrelated quote as an implant testimonial.
  return GOOGLE_REVIEWS.filter(r=>!wanted.length || r.topics.some(t=>wanted.includes(t))).slice(0,limit);
}
